module.exports = __webpack_public_path__ + "img/相続税を調べる.46c35b39.png";